import { useCallback, useEffect, useRef } from "react";

type Options = {
  count?: number;
  timeout?: number;
};

export const useMultiClick = (
  onTrigger: () => void,
  { count = 5, timeout = 1500 }: Options = {},
) => {
  const clickCount = useRef(0);
  const resetTimer = useRef<number | null>(null);
  const onTriggerRef = useRef(onTrigger);
  onTriggerRef.current = onTrigger;

  useEffect(() => {
    return () => {
      if (resetTimer.current !== null) {
        window.clearTimeout(resetTimer.current);
        resetTimer.current = null;
      }
    };
  }, []);

  return useCallback(() => {
    clickCount.current += 1;

    if (resetTimer.current !== null) {
      window.clearTimeout(resetTimer.current);
    }
    resetTimer.current = window.setTimeout(() => {
      clickCount.current = 0;
      resetTimer.current = null;
    }, timeout);

    if (clickCount.current >= count) {
      clickCount.current = 0;
      if (resetTimer.current !== null) {
        window.clearTimeout(resetTimer.current);
        resetTimer.current = null;
      }
      onTriggerRef.current();
    }
  }, [count, timeout]);
};
